// PhoneLink -- renders a phone number as a tel: link that any installed
// phone app (Aircall, Dialpad, FaceTime, OS dialer) will pick up.
//
// Aircall integration (Dave 2026-06-30):
//   The Aircall Click-to-Dial Chrome extension auto-detects every
//   phone number on a webpage and overlays its own "Call with Aircall"
//   button when the user hovers. It also intercepts tel: clicks once
//   installed. So we don't need a vendor-specific deep-link button --
//   the bare tel: link plus the extension does everything we need.
//
// E.164 normalization: tel: works with display formatting but a
// fully-qualified +1XXXXXXXXXX number is more robust across handlers
// and matches Aircall's webhook payload format exactly (so when Phase
// B lands, caller-ID lookups can match cleanly).
//
// Usage:
//   <PhoneLink number={customer.phone_cell} label="Cell" />
//   <PhoneLink number={lead.phone_main} />                    // no label

export default function PhoneLink({ number, label = null, className = '' }) {
  if (!number) return null;
  const digits = String(number).replace(/\D/g, '');
  if (digits.length === 0) return null;
  // Add +1 for 10-digit NANP numbers; leave anything else as-is.
  const e164 = digits.length === 10
    ? `+1${digits}`
    : (digits.startsWith('1') && digits.length === 11 ? `+${digits}` : `+${digits}`);
  const display = String(number); // preserve operator-entered formatting
  return (
    <span className={`phone-link ${className}`.trim()} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {label && <span style={{ color: 'var(--color-text-dim)', marginRight: 4 }}>{label}:</span>}
      <a
        href={`tel:${e164}`}
        className="cell-mono"
        style={{ color: 'inherit', textDecoration: 'none', borderBottom: '1px dotted var(--color-text-faint)' }}
        title="Call (Aircall extension or OS default)"
      >
        {display}
      </a>
    </span>
  );
}
